import { Button } from 'components/atoms';
import { MagellanPopups } from 'components/molecules';
import { Form } from 'components/organisms';
import { useParamId } from 'hooks/useParamId';
import middleware from 'middleware';
import { useTranslation } from 'react-i18next';
import { PiPencilSimpleLine } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { PopupActions } from 'reactjs-popup/dist/types';
import {
  useDeleteAgreementTemplate,
  useGetAgreementTemplate,
} from 'services/templates/agreement-template';
import { contractTemplateUtil } from 'utils';
import { onErrorShowToast } from 'utils/service/errorHandler';

const AgreementTemplate = () => {
  const id = useParamId('/templates-extended');
  const { t } = useTranslation();
  const navigate = useNavigate();

  const agreementTemplate = useGetAgreementTemplate(id);

  const removeAgreementTemplate = useDeleteAgreementTemplate(id);

  const name = agreementTemplate.data
    ? agreementTemplate.data?.title
    : undefined;

  const onRemoveAgreementTemplateTemplate = async (actions: PopupActions) => {
    await removeAgreementTemplate.mutateAsync(undefined, {
      onError: error => {
        actions.close();
        onErrorShowToast(error);
      },
      onSuccess: () => navigate('/templates-extended'),
    });
  };

  return (
    <Form.Contract
      tittle={name ?? t('contract-template.agreement.title')}
      backPath={'templates-extended'}
      topbarContent={
        <div className='flex'>
          <Button
            isClear
            onlyIcon
            onClick={() =>
              navigate(`/templates-extended/agreement/edit/${id}/form`, {
                replace: true,
              })
            }>
            <Button.Icon icon={<PiPencilSimpleLine />} />
          </Button>
          <MagellanPopups.DeleteWarning
            onRemove={onRemoveAgreementTemplateTemplate}
            removeLoading={removeAgreementTemplate.isPending}
            name={name}
          />
        </div>
      }
      initialStatus={{...contractTemplateUtil.agreement.initialStatus, displayMode: true}}
      initialValues={
        agreementTemplate.data
          ? middleware.template.agreement.queryToForm(agreementTemplate.data)
          : contractTemplateUtil.agreement.initialValues()
      }
      onSubmit={() => {}}
      status={{ displayMode: true, isLoading: agreementTemplate.isLoading }}
    />
  );
};

export default AgreementTemplate;
